export default "__VITE_ASSET__De08Gygh__"